// @flow
import $ from 'jquery';
import React, {useEffect} from 'react';

const Popup = ({useFade}) => {
    
    useEffect(() => {
        $(document).off('shown.bs.modal', '#liModalPopup');
        $(document).on('shown.bs.modal', '#liModalPopup', function (e) {
            $("#liCloseBTN").focus();
        });
        $(document).off('hidden.bs.modal','#liModalPopup');
        return (() => { // unmount
            console.debug(">>> unmounting popup");
            $('#liModalPopup').modal('hide');
            $('.modal-backdrop').remove();
            $("#liConfirmInput").off("keyup",null,null,Popup.gotTextChanged);
        });
    }, [])
    
    return (
        <div className={"modal "+(useFade===true?"fade":"")} tabIndex="-1" id="liModalPopup" role="dialog" aria-labelledby="liPopup"
             aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content li-modal-content">
                    <div className="modal-header li-modal-header" id="liPopupHeader">
                        <h4 className="modal-title" id="liPopupTitle">-</h4>
                        <button id="liPopupClose" type="button" className="close" data-dismiss="modal" aria-label="close" onClick={(e) => Popup.hide(e)}>
                            <i className="fa fa-close"/>
                        </button>
                    </div>

                    <div className="modal-body" id="liPopupBody">
                        This is the body of the popup.
                    </div>
                    <div className="modal-footer border-0 w-100">
                        <button className="li-button li-primary li-button-height-auto" id="liCloseBTN" onClick={(e) => Popup.hide(e)}>Close</button>
                        <button className="li-button li-secondary li-button-height-auto" id="liOkBTN" onClick={(e) => Popup._ok(e)}>Ok</button>
                        <button className="li-button li-tertiary li-button-height-auto" id="liExtraBTN" onClick={(e) => Popup._extraClicked(e)}>Extra</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

Popup.propTypes = {};

export default Popup;

Popup.gPopupOnClose=undefined;
Popup.gPopupOnOk=undefined;
Popup.gPopupOnExtra=undefined;

Popup._showTitleIfNeeded = (title, color) => {
    $('#liModalPopup .modal-header').css({'background': color});
    const titleBar = $('#liPopupHeader');
    if (!title || title === "") {
        titleBar.hide();
    } else {
        titleBar.show();
        $('#liModalPopup #liPopupTitle').html(title);
    }
}

Popup.focus = () => {
    $("#liCloseBTN").focus();
}

Popup._noTitle = () => {
    const titleBar = $('#liPopupHeader');
    titleBar.hide();
}

Popup._showCloseBtn = (showFlag, buttonText=null) => {
    if(showFlag) {
        const closeBTN = $("#liCloseBTN");
        buttonText?closeBTN.text(buttonText):closeBTN.text("Close"); // ensure close? if not specified
        closeBTN.show();
    }
    else {
        $("#liCloseBTN").hide();
    }
}

Popup._showBody = (message, allowOutOfBandClose:boolean=false, centered:boolean=false, maxWidth:number=0, maxHeight:number=0) => {
    const el = $('#liModalPopup');
    
    $("#liOkBTN").hide();
    $("#liExtraBTN").hide();
    const theMain = $('#liModalPopup .modal-content');
    if(maxWidth>0) {
        theMain.css('max-width', maxWidth > 0 ? maxWidth + "px" : "");
        theMain.css('margin-left', "auto");
        theMain.css('margin-right', "auto");
    }
    else {
        theMain.css('max-width', "");
        theMain.css('margin-left', "");
        theMain.css('margin-right', "");
    }
    if(maxHeight>0) {
        theMain.css('max-height', maxHeight > 0 ? maxHeight + "px" : "");
        theMain.css('overflow-y', "auto");
    }
    else {
        theMain.css('max-height', "");
        theMain.css('overflow-y', "");
    }
    const theBody = $('#liPopupBody');
    theBody.css('text-align', centered?"center":"left");
    theBody.html(message);

    // Set up hidden.bs.modal handler BEFORE showing the modal
    // This ensures gPopupOnClose runs regardless of how the modal is dismissed
    // (button click, backdrop click, ESC key, etc.)
    el.off('hidden.bs.modal');
    el.on('hidden.bs.modal', function (e) {
        console.debug("Modal hidden - checking for onClose callback");
        if (Popup.gPopupOnClose) {
            const content = $("#liConfirmInput").val();
            console.debug("Running onClose...");
            Popup.gPopupOnClose(content);
        }
    });

    if(allowOutOfBandClose) {
        console.debug(">>> OOB allowed ");
        el.modal({
            backdrop: true,         // backdrop, but CAN be removed with outside click
            keyboard: false
        });
    }
    else {
        console.debug(">>> NOT OOB ");
        el.modal();
        el.off("click");   // we don't want clicks handled by backdrop
    }
}

/**
 * show a popup with a simple title, message and a single close button.
 * 
 * @param title
 * @param message
 * @param onClose
 */
Popup.show = (title, message, onClose) => {
    Popup._clearActions();

    Popup._showCloseBtn(true);
    Popup._showTitleIfNeeded(title, '#e0e0e0');
    Popup._showBody(message);
    Popup.gPopupOnClose = onClose;
}

Popup.gotTextChanged = (e) => {
    if(e.target.value!=="") {
        //console.debug("value is "+$("#liConfirmInput").val());
        $("#liOkBTN").prop('disabled',false);
    }
    else {
        $("#liOkBTN").prop('disabled',true);
    }
}

/** Show a prompt text area and let the user type some stuff in that's returned
 *  when they push OK.
 *
 * @param title
 * @param defaultText
 * @param okBtnText
 * @param onClose
 * @param onOk
 * @param rows - number of rows in the text area (default=3)
 * @param placeholder - the text to show as a placeholder in the prompt (default='type your message')
 */
Popup.showPrompt = (title, defaultText, okBtnText, onClose, onOk, rows = 3, placeholder="type your message") =>{
    Popup._clearActions();
    
    let textInput = `<textarea class='form-control' autofocus rows=${rows} spellcheck=true id='liConfirmInput' placeholder='${placeholder}'>`;
    textInput += defaultText + "</textarea>";
    Popup.show(title, textInput, onClose); // same.

    const okBTN = $("#liOkBTN");
    const textInputWidget = $("#liConfirmInput");
    if (okBtnText && okBtnText !== "") {
        okBTN.text(okBtnText);
        if(textInputWidget) {
            okBTN.prop('disabled', true);
        }
        okBTN.show();
    }
    Popup.gPopupOnOk = onOk;

    $(document).one('shown.bs.modal', '#liModalPopup', function (e) {
        textInputWidget.focus();
    });
    
    textInputWidget.on("keyup",null,null,Popup.gotTextChanged); // added by pott - 230905
    
    // Prevent Enter key from adding new lines when rows=1 (and allow Enter key to add new lines when rows>1)
    // If rows=1 then enter key should essentially press the ok button
    if (rows === 1) {
        textInputWidget.on("keydown", function(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                Popup._ok();
                return false;
            }
        });
    }
    else { // allow the Enter key to add new lines
        textInputWidget.on("keydown", function(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                return true;
            }
        });
    }
}

/**
 * show this popup as a confirmation with 2 or 3 buttons for choices and what to
 * do for each button choice.
 *
 * @param title - the title of the popup
 * @param msg - the message to show
 * @param okBtnText - the text to show on the OK button (default='OK')
 * @param onClose - the function to run when the close button is clicked
 * @param onOk - the function to run when the OK button is clicked
 * @param extraBtnText - the text to show on the extra butto (not shown in the default case)
 * @param onExtra - the function to run when the extra button is clicked
 * @param closeBtnText - the text to show on the close button (default='Close')
 */
Popup.showConfirm = (title, msg, okBtnText, onClose, onOk, extraBtnText, onExtra, closeBtnText) =>{
    Popup._clearActions();
    
    Popup.show(title, msg, onClose); // same.
    const okBTN = $("#liOkBTN");
    okBTN.prop('disabled', false);
    if (okBtnText && okBtnText !== "") {
        okBTN.text(okBtnText);
        okBTN.show();
    }
    const closeBTN = $("#liCloseBTN");
    if (closeBtnText && closeBtnText !== "") {
        closeBTN.text(closeBtnText);
        closeBTN.show();
    }
    const extraBTN = $("#liExtraBTN");
    if (extraBtnText && extraBtnText !== "") {
        extraBTN.text(extraBtnText);
        extraBTN.show();
    }
    Popup.gPopupOnOk=onOk;
    Popup.gPopupOnExtra=onExtra;
}

/**
 * show this popup with a red banner - as an error
 * 
 * @param title
 * @param message
 * @param onClose
 */
Popup.showError = (title, message, onClose)=> {
    Popup._clearActions();
    
    Popup._showCloseBtn(true);
    Popup._showTitleIfNeeded(title, 'indianred');
    Popup._showBody(message);
    Popup.gPopupOnClose = onClose;
}

/**
 * show the popup with no buttons, just an OutOfBounds close available
 * (minimal decoration)
 * @param message - the message to show
 * @param centered - if true, the text within the popup is centered
 * @param maxWidth - if set, will set the max-width of the popup to this value
 * @param allowOutOfBandClose - if true, the popup can be closed by clicking outside of it (default=true)
 * @param maxHeight
 */
Popup.showInfo = (message, centered:boolean=false, maxWidth:number=0, allowOutOfBandClose:boolean=true, maxHeight:number=0) => {
    Popup._clearActions();
    
    Popup._noTitle();
    Popup._showCloseBtn(false);
    Popup._showBody(message, allowOutOfBandClose, centered, maxWidth, maxHeight);
}

/**
 * show the popup with a close button and a message
 * (minimal decoration)
 * @param message - the message to show
 * @param centered - if true, the text within the popup is centered
 * @param maxWidth - if set, will set the max-width of the popup to this value
 * @param allowOutOfBandClose - if true, the popup can be closed by clicking outside of it (default=true)
 * @param onClose - a function to run when the popup is closed
 * @param maxHeight
 */
Popup.showInfoWithButton = (message, onClose:function=()=>{}, centered:boolean=false, maxWidth:number=0, allowOutOfBandClose:boolean=true, maxHeight:number=0) => {
    Popup._clearActions();

    Popup._noTitle();
    Popup._showCloseBtn(true);
    Popup._showBody(message, allowOutOfBandClose, centered, maxWidth, maxHeight);
    Popup.gPopupOnClose = onClose;
}

/**
 * show the popup with a close button and a message and timed autoclose
 * (minimal decoration)
 * @param message - the message to show
 * @param centered - if true, the text within the popup is centered
 * @param maxWidth - if set, will set the max-width of the popup to this value
 * @param allowOutOfBandClose - if true, the popup can be closed by clicking outside of it (default=true)
 * @param onClose - a function to run when the popup is closed
 * @param delay - if non-zero with be the MSecs to wait before auto closing.
 * @param maxHeight
 */
Popup.showInfoWithButtonTimed = (message, onClose:function=()=>{}, centered:boolean=false, maxWidth:number=0, allowOutOfBandClose:boolean=true, delay:number=0, maxHeight:number=0) => {
    Popup._clearActions();

    Popup._noTitle();
    Popup._showCloseBtn(true);
    Popup._showBody(message, allowOutOfBandClose, centered, maxWidth, maxHeight);
    Popup.gPopupOnClose = onClose;
    if(delay>0) {
        setTimeout(() => {
            Popup.hide();
        }, delay);
    }
}

/**
 * show the info popup (no title or buttons) for a period of time
 * @param message
 * @param delay
 * @param centered
 * @param maxWidth
 * @param allowOutOfBandClose
 * @param maxHeight
 */
Popup.showInfoTimed = (message, delay, centered:boolean=false, maxWidth:number=0, allowOutOfBandClose:boolean=true, maxHeight:number=0) => {
    Popup._clearActions();

    Popup._noTitle();
    Popup._showCloseBtn(false);
    Popup._showBody(message, allowOutOfBandClose, centered, maxWidth, maxHeight);
    if (delay && delay>0) { // set a delay to close the popup
        setTimeout(() => {
            Popup.hide();
        }, delay);
    }
}

/**
 * force a hide of the current popup (this still runs any onClose method
 * that was hooked up during the show())
 * @param event
 */
Popup.hide = (event) => { // SAME AS CLOSE
    event?.preventDefault();
    event?.stopPropagation();
    // The hidden.bs.modal handler is already set up in _showBody()
    // It will automatically call gPopupOnClose when the modal hides
    $('#liModalPopup').modal('hide');
}

Popup._ok = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    // Temporarily replace gPopupOnClose with gPopupOnOk so the hidden.bs.modal handler
    // (set up in _showBody) calls the OK callback instead of the close callback
    const $modal = $('#liModalPopup');
    Popup.gPopupOnClose = Popup.gPopupOnOk;
    $modal.modal('hide');
 }

Popup._extraClicked = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    // Temporarily replace gPopupOnClose with gPopupOnExtra so the hidden.bs.modal handler
    // (set up in _showBody) calls the Extra callback instead of the close callback
    const $modal = $('#liModalPopup');
    Popup.gPopupOnClose = Popup.gPopupOnExtra;
    $modal.modal('hide');
}

Popup._clearActions = () => {
    Popup.gPopupOnClose=undefined;
    Popup.gPopupOnOk=undefined;
    Popup.gPopupOnExtra=undefined;
}
